import {handleDefaultValues} from "../../common/Utils";
import React, {useContext, useState} from "react";
import MDButton from "../../../components/MDButton";
import {DesktopDatePicker, DesktopDateTimePicker} from "@mui/x-date-pickers";
import {useForm} from "react-hook-form";
import MDBox from "../../../components/MDBox";
import {saveCartForm} from "../api/CartApi";
import {AppContext} from "../../../lib/AppContext";

export default function CartForm({client, callback, form}) {

  const [cartContext, setCartContext] = useContext(AppContext);

  const [renderIdx, setRenderIdx] = useState(1);
  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(form)
  });

  const [saving, setSaving] = useState(false);

  const saveForm = async (formData) => {
    let _formData = {...formData};
    let _answers = [];
    for (let a in _formData.answer) {
      let _answer = {
        questionGuid: a,
        answer: _formData.answer[a]
      }
      _answers.push(_answer);
    }
    _formData.answers = [..._answers];

    setSaving(true)
    saveCartForm(client.guid, _formData).then((resp) => {
      callback()
      setSaving(false);
    });
  }

  const displayQuestion = (item) => {
    if (item.questionType.id === 1) {
      return <div className={'col col-sm-12 col-md-12 col-lg-9'}>
        <label>{item.questionLabel}{item.required ? ' *' :''}</label>
        <input type={"text"} className={'form-control'}
               {...register(`answer.${item.questionGuid}`, {
                 required: item.required
               })}
               required={item.required}
               placeholder={item.description}/></div>
    }
    if (item.questionType.id === 2) {
      return <div className={'col col-sm-12 col-md-12 col-lg-9'}>
        <label>{item.questionLabel}{item.required ? ' *' :''}</label>
        <textarea
          {...register(`answer.${item.questionGuid}`, {
            required: item.required
          })}
          className={'form-control'} required={item.required}
          placeholder={item.description}/></div>
    }

    if (item.questionType.id === 3) {
      return <div className={'col col-sm-12 col-md-12 col-lg-9'}>
        <label><input
          {...register(`answer.${item.questionGuid}`, {
            required: item.required
          })}
          type="checkbox"
          role={'switch'}
          id="reminderNote"
          className={'form-check-input'}
          required={item.required}
        />&nbsp;{item.questionLabel}{item.required ? ' *' :''}</label>
        <p><small>{item.questionDescription}</small></p>
      </div>
    }

    if (item.questionType.id === 4) {
      return <div className={'col col-sm-12 col-md-12 col-lg-9'}>
        <label htmlFor="state">{item.questionLabel}{item.required ? ' *' :''}</label>
        <input type={"number"} className={'form-control'}
               {...register(`answer.${item.questionGuid}`, {
                 required: item.required
               })}
               required={item.required}
               placeholder={item.description}/></div>
    }

    if (item.questionType.id === 5) {
      return <div className={'col col-sm-12 col-md-12 col-lg-9'}>
        <div className="form-group">
          <label htmlFor="billingEndDate">{item.questionLabel}{item.required ? ' *' :''}</label>
          <div>
            <DesktopDatePicker
              {...register(`answer.${item.questionGuid}`, {
                required: item.required
              })}
              slotProps={{
                popper: {
                  sx: {
                    padding: '20px'
                  },
                  disablePortal: true,
                  placement: 'right-end',
                },
                actionBar: {
                  actions: ['today'],
                },
              }}
              value={null}
              onChange={(e) => {

              }}
            />
          </div>
        </div>
      </div>
    }

    if (item.questionType.id === 6) {
      return <div className={'col col-sm-12 col-md-12 col-lg-9'}>
        <div className="form-group">
          <label htmlFor="billingEndDate">{item.questionLabel}{item.required ? ' *' :''}</label>
          <div>
            <DesktopDateTimePicker
              {...register(`answer.${item.questionGuid}`, {
                required: item.required
              })}
              slotProps={{
                popper: {
                  sx: {
                    padding: '20px'
                  },
                  disablePortal: true,
                  placement: 'right-end',
                },
                actionBar: {
                  actions: ['today'],
                },
              }}
              value={null}
              onChange={(e) => {

              }}
            />
          </div>
        </div>
      </div>
    }

    if (item.questionType.id === 7) {
      return <div className={'col col-sm-12 col-md-12 col-lg-9'}>
        <div className="form-group">
          <h5 htmlFor="billingEndDate">{item.questionLabel}</h5>
          <div>
            <p style={{
              whiteSpace: 'pre-wrap'
            }}>{item.description}</p>
          </div>
        </div>
      </div>
    }

    return <>&nbsp;</>
  }

  return (
    <div>
      {form && <>

        <form>
          <h5>{form.formName} </h5>
          <div style={{
            border: 'solid 1px #ddd',
            display: 'block',
            width: '100%',
            minHeight: '200px',
          }}>
            {form?.questions?.length > 0 && <>

              <div className="d-block">
                <MDBox m={2} p={3}>
                  {renderIdx && form?.questions?.sort((a, b) => a.sortOrder - b.sortOrder).map((q, index) => {
                    return (
                      <MDBox m={1} key={index}>
                        <div>
                          {displayQuestion(q)}
                        </div>
                      </MDBox>
                    )
                  })
                  }
                </MDBox>
              </div>
            </>
            }

          </div>

          <MDButton
            color="info"
            disabled={saving}
            onClick={handleSubmit(saveForm)}
            className={'btn btn-primary my-2 pull-right'}
          >{saving ? 'Saving...' : 'Save'}
          </MDButton>
        </form>
      </>
      }
    </div>
  )
}